<template>
    <!--
           作者：peng
           时间：2020-08-18
           描述：插件中心-客户资源
       -->
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName">
                <el-tab-pane label="客户列表" name="customer">
                    <Customer v-if="activeName=='customer'"></Customer>
                </el-tab-pane>
                <el-tab-pane label="基础设置" name="setting">
                    <Setting v-if="activeName=='setting'"></Setting>
                </el-tab-pane>
               <!-- <el-tab-pane label="自定义文字" name="open">
                    <Open v-if="activeName=='open'"></Open>
                </el-tab-pane>-->
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import Customer from './customer/index.vue';
    import Setting from './setting/setting.vue';
    import Open from './open/open';
    export default {
        components: {
            Customer,
            Setting,
            Open
        },
        data() {
            return {
                activeName: 'customer',
                /*是否加载完成*/
                loading: true,
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/plus/customer/index.vue